import request from '@/utils/request'

// 获取过磅列表
export function getHistoryList(params) {
  return request.get('/productLoading/list', { params })
}

// 获取消息推送列表
export function getList(data) {
  return request.get('/loadingConfig/list')
}

// 更新消息推送信息
export function updateOne(data) {
  return request.post('/loadingConfig/update', data)
}